import { render, staticRenderFns } from "./BenefitsUpdate.vue?vue&type=template&id=9bcd8ac4"
import script from "./BenefitsUpdate.vue?vue&type=script&lang=js"
export * from "./BenefitsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports